import React, { useState } from 'react';
import {useNavigate} from "react-router-dom";
import axios from "axios";
import { Form, Button, Container, Alert } from 'react-bootstrap';


const AddNSE = () => {
  const baseURL = "https://nseapi.maclogi.com/api/";
  //const baseURL = "http://localhost:3000/api/";
  const navigate = useNavigate();



  const [enterednseid, setNSEId] = useState(0);
  const [enterednsedate, setNSEDate] = useState('');
  const [enterednseopen, setNSEOpen] = useState(0);
  const [enterednsehigh, setNSEHigh] = useState(0);
  const [enterednselow, setNSELow] = useState(0);
  const [enterednseclose, setNSEClose] = useState(0);
  const [enterednsebuy, setNSEBuy] = useState(0);
  const [enterednsesell, setNSESell] = useState(0);

    const nseidchangehandler = (event) => {
      setNSEId(event.target.value);
  };

  const nsedatechangehandler = (event) => {
    setNSEDate(event.target.value);
};

const nseopenchangehandler = (event) => {
  setNSEOpen(event.target.value);
};

const nsehighchangehandler = (event) => {
  setNSEHigh(event.target.value);
};

const nselowchangehandler = (event) => {
  setNSELow(event.target.value);
};

const nseclosechangehandler = (event) => {
  setNSEClose(event.target.value);
};

const nsebuychangehandler = (event) => {
  setNSEBuy(event.target.value);
};

const nsesellchangehandler = (event) => {
  setNSESell(event.target.value);
};


 const submitActionHandler = (event) => {
    event.preventDefault();
    axios
      .post(baseURL + "nses", {
        nseid: enterednseid,
        nsedate: enterednsedate,
        nseopen: enterednseopen,
        nsehigh: enterednsehigh,
        nselow: enterednselow,
        nseclose: enterednseclose,
        nsebuy: enterednsebuy,
        nsesell: enterednsesell
      })
      .then((response) => {
        alert("NSE "+ enterednsedate +" added!");
        navigate("/nsedetails");
      }).catch(error => {
        alert("error==="+error);
      });

  };

  const cancelHandler = () =>{
    navigate("/nsedetails");
  }
    return(
      <Alert variant='primary' class="col-xs-6 col-sm-6">
      <Container>
      <Form onSubmit={submitActionHandler}>
         <Form.Group controlId="form.nseid">
            <Form.Label>Id</Form.Label>
            <Form.Control type="text" value={enterednseid} onChange={nseidchangehandler} placeholder="Enter NSE Id" required/>
          </Form.Group>
          <Form.Group controlId="form.nsedate">
            <Form.Label>Date</Form.Label>
            <Form.Control type="text" value={enterednsedate} onChange={nsedatechangehandler} placeholder="Enter NSE Date" required/>
          </Form.Group>
          <Form.Group controlId="form.nseopen">
            <Form.Label>Open</Form.Label>
            <Form.Control type="text" value={enterednseopen} onChange={nseopenchangehandler} placeholder="Enter NSE Open" required/>
          </Form.Group>
          <Form.Group controlId="form.nsehigh">
            <Form.Label>High</Form.Label>
            <Form.Control type="text" value={enterednsehigh} onChange={nsehighchangehandler} placeholder="Enter NSE High" required/>
          </Form.Group>
          <Form.Group controlId="form.nselow">
            <Form.Label>Low</Form.Label>
            <Form.Control type="text" value={enterednselow} onChange={nselowchangehandler} placeholder="Enter NSE Low" required/>
          </Form.Group>
          <Form.Group controlId="form.nseclose">
            <Form.Label>Close</Form.Label>
            <Form.Control type="text" value={enterednseclose} onChange={nseclosechangehandler} placeholder="Enter NSE Close" required/>
          </Form.Group>
          <Form.Group controlId="form.nsebuy">
            <Form.Label>Buy</Form.Label>
            <Form.Control type="text" value={enterednsebuy} onChange={nsebuychangehandler} placeholder="Enter NSE Buy" required/>
          </Form.Group>
          <Form.Group controlId="form.nsesell">
            <Form.Label>Sell</Form.Label>
            <Form.Control type="text" value={enterednsesell} onChange={nsesellchangehandler} placeholder="Enter NSE Sell" required/>
          </Form.Group>
        <br></br>
        <Button type='submit'>Save</Button>
        &nbsp;&nbsp;&nbsp;
        <Button type='submit' onClick={()=>cancelHandler()}>Cancel</Button>
      </Form>

    </Container>
    </Alert>

    );
}
export default AddNSE;